import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const CircleTimerIcon = ({ className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 40 40"
        className={className}
        xmlSpace="preserve"
        strokeDasharray="188.5"
    >
        <circle
            cx="20"
            cy="20"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.65"
            r="18"
        />
    </svg>
);

CircleTimerIcon.propTypes = propTypes;
CircleTimerIcon.defaultProps = defaultProps;

export default CircleTimerIcon;
